import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef,OnChanges,SimpleChanges, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { RadicationSS } from '../../../class/radicationSS';
import { RadicationSSService } from '../../../service/radicationSS/radicationSS.service';
import { TranslateService } from '@ngx-translate/core';
import { Message, SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { ContractService } from '../../../service/contract/contract.service';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { Contract } from '../../../class/contract';
import { config } from '../../../../../../environments/config';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { formatDateWithoutHour } from '../../../../../theme/functions/formatDateWithoutHour.function';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-radication-ss',
  templateUrl: './new-radication-ss.component.html',
  styleUrls: ['./new-radication-ss.component.scss']
})
export class NewRadicationSSComponent implements OnInit,OnChanges {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: RadicationSS;
    @Input() gestionSac: any;
    @ViewChild('fileUpload') fileUpload: any;

    messages: Message[] = [];

    public promiseForm: Promise<any>;
    public form: FormGroup;
    public activated: AbstractControl;
    public company_id: AbstractControl;
    public candidate_id: AbstractControl;
    // public affiliation_name: AbstractControl;
    // public identification_number: AbstractControl;
    public eps_ccf: AbstractControl;
    public department_id: AbstractControl;
    public venue_id: AbstractControl
    public tramite: AbstractControl;
    public date_delivery: AbstractControl;
    public beneficiaries_registered: AbstractControl;
    public observations_facilitator: AbstractControl;
    public received: AbstractControl;
    public received_by_id: AbstractControl;
    public date_received: AbstractControl;
    public devolution: AbstractControl;
    public devolution_by_id: AbstractControl;
    public date_devolution: AbstractControl;
    public transacted: AbstractControl;
    public transacted_by_id: AbstractControl;
    public date_transacted: AbstractControl;
    public report_user_id: AbstractControl;
    public solution: AbstractControl;
    public sel_contracts_available: AbstractControl;
    public optionsSelectionEps_ccf: any[];
    public optionsSelectionTramite: any[];
    public es: any;
    public optionsSelectionBeneficiariesRegistered: any[];
    public optionsSelectionReceivedTransacted: any[];
    public optionsSelectionDevolutionTransacted: any[];

    public apiUrl = config.API_ROOT;

    
    public uploadedAttachment: any[] = [];
    public prewiewFileAttachment: any;
    public promiseAttachment: Promise<any>;
    public type_retirement: AbstractControl;
    // public optionsTypeRetirement: any[];
    public listDocuments: any[] = [];
    public loading_upload: boolean;
    public result: any;
    public selectContract: any;
    public selectContractType: string;
    public blockCandiateAndContract: boolean;
    
    public departmentPositionToLoad: string;
    public companySelected: string;
    
    public disabledCandidate: boolean;
    public disabledNameIdentification: boolean;
    public modViewDialog: boolean;

    public myEmployeeId: string;

    public save_exit: boolean;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public msgs: Message[] = [];
    public contracts: Contract[];
    public filters: any[];
    public select_candidate_id: string;
    public select_doc_id: number;
    public modViewDialogDocumentation: boolean;
    public results_contracts_availables: boolean;
    public contractsOptions: any[];
    public selectContractId: number;
    public list_contracts: any[];
    public listdocumentedit:number;
    public firtsOnce: boolean;
    public cancelInvalid: boolean;

    constructor(
        fb: FormBuilder,
        public radicationSSService: RadicationSSService,
        public translate: TranslateService,
        private notificationsService: NotificationsService,
        public contractService: ContractService,
        public uploadFilesService: UploadFilesService,
        public hasPermissionService: HasPermissionService,
        private router: Router) {
        this.modViewDialog = false;
        
        this.save_exit = false;

        // this.departmentPositionToLoad = '6,8';

        this.es = calendarES();

        this.optionsSelectionEps_ccf = [];
            this.optionsSelectionEps_ccf.push({label: 'Aliansalud', value: 'Aliansalud'});
            this.optionsSelectionEps_ccf.push({label: 'Cafesalud E.P.S', value: 'Cafesalud E.P.S'});
            this.optionsSelectionEps_ccf.push({label: 'Caprecom E.P.S', value: 'Caprecom E.P.S'});
            this.optionsSelectionEps_ccf.push({label: 'Compensar E.P.S', value: 'Compensar E.P.S'});
            this.optionsSelectionEps_ccf.push({label: 'Coomeva E.P.S - S.A', value: 'Coomeva E.P.S - S.A'});
            this.optionsSelectionEps_ccf.push({label: 'Colsubsidio CCF', value: 'Colsubsidio CCF'});
            this.optionsSelectionEps_ccf.push({label: 'Comfenalco Antioquia ', value: 'Comfenalco Antioquia             '});
            this.optionsSelectionEps_ccf.push({label: 'Comfamiliar de Risaralda', value: 'Comfamiliar de Risaralda'});
            this.optionsSelectionEps_ccf.push({label: 'Comfenalco Quindio', value: 'Comfenalco Quindio'});
            this.optionsSelectionEps_ccf.push({label: 'Comfamiliar Caldar', value: 'Comfamiliar Caldar'});
            this.optionsSelectionEps_ccf.push({label: 'Comfachoco ', value: 'Comfachoco '});
            this.optionsSelectionEps_ccf.push({label: 'Comfachoco EPS ', value: 'Comfachoco EPS '});
            this.optionsSelectionEps_ccf.push({label: 'COMFAMA ANT', value: 'COMFAMA ANT'});
            this.optionsSelectionEps_ccf.push({label: 'Cruz Blanca E.P.S', value: 'Cruz Blanca E.P.S'});
            this.optionsSelectionEps_ccf.push({label: 'E.P.S Convida', value: 'E.P.S Convida'});
            this.optionsSelectionEps_ccf.push({label: 'E.P.S Sanitas S.A', value: 'E.P.S Sanitas S.A'});
            this.optionsSelectionEps_ccf.push({label: 'E.P.S Servicio Occidental De Salud S.O.S - S.A', value: 'E.P.S Servicio Occidental De Salud S.O.S - S.A'});
            this.optionsSelectionEps_ccf.push({label: 'Famisanar Ltda', value: 'Famisanar Ltda'});
            this.optionsSelectionEps_ccf.push({label: 'Nueva E.P.S', value: 'Nueva E.P.S'});
            this.optionsSelectionEps_ccf.push({label: 'Nueva E.P.S', value: 'Nueva E.P.S'});
            this.optionsSelectionEps_ccf.push({label: 'Salud Total S.A', value: 'Salud Total S.A'});
            this.optionsSelectionEps_ccf.push({label: 'Solsalud E.P.S', value: 'Nueva E.P.S'});
            this.optionsSelectionEps_ccf.push({label: 'Susaludc E.P.S', value: 'Susaludc E.P.S'});
            this.optionsSelectionEps_ccf.push({label: 'Sura EPS', value: 'Sura EPS'});



        this.optionsSelectionTramite = [];
            this.optionsSelectionTramite.push({label: 'Inclusión EPS', value: '116'});
            this.optionsSelectionTramite.push({label: 'Traslado EPS', value: '117'});
            this.optionsSelectionTramite.push({label: 'Inclusión CCF', value: 'Inclusión CCF'});
            this.optionsSelectionTramite.push({label: 'Aclaracion inquietud nomina', value: 'Aclaracion inquietud nomina'});
            this.optionsSelectionTramite.push({label: 'Certificacion electrónica', value: 'Certificacion electrónica'});
            this.optionsSelectionTramite.push({label: 'Carta de Cesantias', value: 'Carta de Cesantias'});
            this.optionsSelectionTramite.push({label: 'Certificado Ingresos y Retenciones', value: 'Certificado Ingresos y Retenciones'});
            this.optionsSelectionTramite.push({label: 'Generación desprendible pago electrónico', value: 'Generación desprendible pago electrónico'});
            this.optionsSelectionTramite.push({label: 'Tramite Carnet ARL', value: 'Tramite Carnet ARL'});
            this.optionsSelectionTramite.push({label: 'Verificación CCF', value: 'Verificación CCF'});
            this.optionsSelectionTramite.push({label: 'Verificacion EPS', value: 'Verificacion EPS'});
            this.optionsSelectionTramite.push({label: 'Ausentismo', value: '115'});
            this.optionsSelectionTramite.push({label: 'Incapacidades', value: '118'});
            this.optionsSelectionTramite.push({label: 'Paz y Salvo', value: '13'});
            this.optionsSelectionTramite.push({label: 'Documento Adicional', value: 'Documento Adicional'});
            this.optionsSelectionTramite.push({label: 'Facturas de servicios', value: 'Facturas de servicios'});
            this.optionsSelectionTramite.push({label: 'Afiliación Fonredes', value: '111'});
            this.optionsSelectionTramite.push({label: 'Proceso Disciplinario', value: '73'});
            this.optionsSelectionTramite.push({label: 'Firma documentos liquidación', value: 'Firma documentos liquidación'});
            this.optionsSelectionTramite.push({label: 'Firma clausula u otro si', value: 'Firma clausula u otro si'});
            this.optionsSelectionTramite.push({label: 'Solicitud devol aportes Fonredes', value: '112'});
            this.optionsSelectionTramite.push({label: 'Solicitud prestamo Fonredes', value: '113'});
            this.optionsSelectionTramite.push({label: 'Terminación de contrato', value: 'Terminación de contrato'});
            this.optionsSelectionTramite.push({label: 'Convenios Fonredes', value: 'Convenios Fonredes'});
            this.optionsSelectionTramite.push({label: 'Modificación de Cuota Fonredes', value: '114'});
            this.optionsSelectionTramite.push({label: 'Aclaración de Dudas', value: 'Aclaración de Dudas'});
            this.optionsSelectionTramite.push({label: 'Actualización de Datos Sortime', value: 'Actualización de Datos Sortime'});
            this.optionsSelectionTramite.push({label: 'Autoliquidación', value: 'Autoliquidación'});
            this.optionsSelectionTramite.push({label: 'Autorización de Descuento', value: 'Autorización de Descuento'});
            this.optionsSelectionTramite.push({label: 'Código de Compra', value: 'Código de Compra'});
            this.optionsSelectionTramite.push({label: 'Validación de Cuenta Bancaria', value: 'Validación de Cuenta Bancaria'});
            this.optionsSelectionTramite.push({label: 'Estractos de Bancos', value: 'Estractos de Bancos'});
            this.optionsSelectionTramite.push({label: 'Tarjetas de Bancos', value: 'Tarjetas de Bancos'});
            this.optionsSelectionTramite.push({label: 'Devoluciones', value: 'Devoluciones'});

            
            this.select_doc_id=0;

        this.optionsSelectionBeneficiariesRegistered = [];
            this.optionsSelectionBeneficiariesRegistered.push({label: 'N/A', value: 'N/A'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '1', value: '1'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '2', value: '2'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '3', value: '3'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '4', value: '4'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '5', value: '5'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '6', value: '6'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '7', value: '7'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '8', value: '8'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '9', value: '9'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '10', value: '10'});

        this.optionsSelectionReceivedTransacted = [];
            this.optionsSelectionReceivedTransacted.push({label: 'No', value: 'No'});
            this.optionsSelectionReceivedTransacted.push({label: 'Si', value: 'Si'});

        this.optionsSelectionDevolutionTransacted = [];
            this.optionsSelectionDevolutionTransacted.push({label: 'No', value: 'No'});
            this.optionsSelectionDevolutionTransacted.push({label: 'Si', value: 'Si'});

        this.form = fb.group({
            'company_id': [''],
            'candidate_id': ['', Validators.compose([Validators.required])],
            // 'affiliation_name': ['', Validators.compose([Validators.required])],
            // 'identification_number': ['', Validators.compose([Validators.required])],
            'eps_ccf': [''],
            'department_id': ['', Validators.compose([Validators.required])],
            'venue_id': ['', Validators.compose([Validators.required])],
            'tramite': ['', Validators.compose([Validators.required])],
            'report_user_id': [''],
            'date_delivery': ['', Validators.compose([Validators.required])],
            'beneficiaries_registered': ['', Validators.compose([Validators.required])],
            'observations_facilitator': ['', Validators.compose([Validators.required])],
            'received': [''],
            'received_by_id': [''],
            'date_received': [''],
            'devolution': [''],
            'devolution_by_id': [''],
            'date_devolution': [''],
            'transacted': [''],
            'transacted_by_id': [''],
            'date_transacted': [''],
            'solution': [''],
            'sel_contracts_available':['']
        });

        // this.activated = this.form.controls['activated'];
        this.company_id = this.form.controls['company_id'];
        this.candidate_id = this.form.controls['candidate_id'];

        // this.affiliation_name = this.form.controls['affiliation_name'];
        // this.identification_number = this.form.controls['identification_number'];
        this.eps_ccf = this.form.controls['eps_ccf'];
        this.department_id = this.form.controls['department_id'];
        this.venue_id = this.form.controls['venue_id'];
        this.tramite = this.form.controls['tramite'];
        this.report_user_id = this.form.controls['report_user_id'];
        this.date_delivery = this.form.controls['date_delivery'];
        this.beneficiaries_registered = this.form.controls['beneficiaries_registered'];
        this.observations_facilitator = this.form.controls['observations_facilitator'];
        this.received = this.form.controls['received'];
        this.received_by_id = this.form.controls['received_by_id'];
        this.date_received = this.form.controls['date_received'];
        this.devolution = this.form.controls['devolution'];
        this.devolution_by_id = this.form.controls['devolution_by_id'];
        this.date_devolution = this.form.controls['date_devolution'];
        this.transacted = this.form.controls['transacted'];
        this.transacted_by_id = this.form.controls['transacted_by_id'];
        this.date_transacted = this.form.controls['date_transacted'];
        this.solution = this.form.controls['solution'];
        this.sel_contracts_available=this.form.controls['sel_contracts_available'];
        
        
        this.listDocuments = [];
        this.loading_upload = false;
        this.modViewDialogDocumentation = false;
        this.results_contracts_availables = false;
        this.blockCandiateAndContract = false;
        this.cancelInvalid = false;
    }
    ngOnChanges(){
        console.log("re");
        //this.ngOnInit();
    }
    
    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        this.sort = '-id';
        this.query = undefined;
        
        if (this.edit) {
            this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;

            // this.activated.setValue(this.edit.activated);
            this.company_id.setValue(this.edit.company_id);
            this.candidate_id.setValue(this.edit.candidate_id);
            // this.affiliation_name.setValue(this.edit.affiliation_name);
            // this.identification_number.setValue(this.edit.identification_number);
            this.eps_ccf.setValue(this.edit.eps_ccf);
            this.department_id.setValue(this.edit.department_id);
            this.venue_id.setValue(this.edit.venue_id);
            this.tramite.setValue(this.edit.tramite);
            if(this.edit.tramite)
            {
                // console.log("El numero "+this.edit.tramite);
                if(!isNaN(this.edit.tramite as any))
                {
                    this.select_doc_id= parseInt(this.edit.tramite);
                    // console.log("this.select_doc_id es: " +this.select_doc_id);
                }
                
                
            }
            
            this.date_delivery.setValue(new Date(this.edit.date_delivery));
            this.beneficiaries_registered.setValue(this.edit.beneficiaries_registered);
            this.observations_facilitator.setValue(this.edit.observations_facilitator);
            this.report_user_id.setValue(this.edit.report_user_id);

            this.received.setValue(parseInt(this.edit.received));
            this.received_by_id.setValue(this.edit.received_by_id);
            if (this.edit.date_received) {
                this.date_received.setValue(new Date(this.edit.date_received));
                this.received.disable();
            }

            this.devolution.setValue(parseInt(this.edit.devolution));
            this.devolution_by_id.setValue(this.edit.devolution_by_id);
            if (this.edit.date_devolution) {
                this.date_devolution.setValue(new Date(this.edit.date_devolution));
                this.devolution.disable();
            }

            
            this.transacted.setValue(parseInt(this.edit.transacted));
            this.transacted_by_id.setValue(this.edit.transacted_by_id);
            if (this.edit.date_transacted) {
                this.date_transacted.setValue(new Date(this.edit.date_transacted));
                this.transacted.disable();
            }

            this.solution.setValue(this.edit.solution);
            this.select_candidate_id=this.edit.candidate_id;
            this.filter_contracts(true);
            if(this.edit.contract_id)
            {
                this.selectContractId=this.edit.contract_id;
                this.filters = [];
                // if(this.select_candidate_id)
                // {  
                this.filters.push({'key': '_q', 'value': this.edit.contract_id});
                this.getContracts();
                // }
                
            }
            
            this.firtsOnce = true;
        } else {
            // this.activated.setValue(true);
            this.received.disable();
            this.devolution.disable();
            this.transacted.disable();
        }
    }

    public cancelRadicationSS () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
        this.router.navigate(['/pages/service-client/radications-ss']);
        //this.location.replaceState('/pages/service-client/radications-ss');
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newRadicationSS(values);
    }

    public newRadicationSS(values) {
        let gestion_sac_id;
        if (this.gestionSac) {
            gestion_sac_id = this.gestionSac.id;
        }

        let company_id;
        if (this.gestionSac) {
            if (this.gestionSac.company_id) {
                company_id = this.gestionSac.company_id;
            }
        } else {
            company_id = values.company_id.id
        }

        let received;
        if (values.received) {
            received =values.received;
        }

        let devolution;
        if (values.devolution) {
            devolution =values.devolution;
        }
        
        let transacted;
        if (values.transacted) {
            transacted =values.transacted;
        }
        let report_user_id;
        if(values.report_user_id){
            report_user_id=values.report_user_id.id;
        }
        let contract_id;
        if(this.selectContract)
            contract_id=this.selectContract.id;
        
            
        const param = {
            'gestion_sac_id': gestion_sac_id,
            'company_id': company_id,
            'candidate_id': values.candidate_id.id,
            // 'affiliation_name': values.affiliation_name,
            // 'identification_number': values.identification_number,
            'eps_ccf': values.eps_ccf,
            'department_id': values.department_id,
            'venue_id': values.venue_id,
            'tramite': values.tramite,
            'date_delivery': formatDateWithoutHour(values.date_delivery),
            'beneficiaries_registered': values.beneficiaries_registered,
            'observations_facilitator': values.observations_facilitator,
            'received': received,
            'devolution': devolution,
            'transacted': transacted,
            'solution': values.solution,
            'report_user_id': report_user_id,
            'contract_id': contract_id
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.radicationSSService.updateRadicationSS(this.edit.id, param)
                :
                this.radicationSSService.newRadicationSS(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        this.edit = response.json();
                        this.cancelInvalid = false;
                        this.firtsOnce=true;
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    public showNewCandidateDialog() {
        this.modViewDialog = true;
    }

    public showResultNewCandidate(msg) {
        this.messages = [];
        this.messages.push(msg);
    }

    public cancelNewCandidate() {
        this.modViewDialog = false;
    }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }

    //---------------------------------------------------------
    public getContracts(query?: string) {
        this.contractService.getContract(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
            response => {
                //this.contracts = response.json().data;
                this.list_contracts = response.json().data;
                this.results_contracts_availables=true;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
                this.contractsOptions = [];
                //this.contractsOptions.push({id: undefined, name: 'Seleccione contrato', company: undefined});
                this.list_contracts.forEach(element => {
                    if (this.selectContractId === element.id) {
                        this.contractsOptions.push({id: element.id, name: "Contrato: "+element.id+" "+"Citación: "+element.citation_id+" "+"Requisición: "+element.requisition_id+" "+"Fecha: "+ element.created_at+" "+"Compañia: "+element.company_name+" "+"Cargo: "+element.employee_position, selected: true,company: element.company});
                        this.selectContract=this.list_contracts[0];
                        this.showDocumentationDialogContract(this.selectContract);
                        this.modViewDialogDocumentation=true;
                    } else {
                        this.contractsOptions.push({id: element.id, name: "Contrato: "+element.id+" "+"Citación: "+element.citation_id+" "+"Requisición: "+element.requisition_id+" "+"Fecha: "+ element.created_at+" "+"Compañia: "+element.company_name+" "+"Cargo: "+element.employee_position, selected: false, company: element.company});
                    }
                    // this.contractsOptions.push({id: element.id, name: "Contrato: "+element.id+" "+"Citación: "+element.citation_id+" "+"Requisición: "+element.requisition_id+" "+"Fecha: "+ element.created_at+" "+"Compañia: "+element.company_name+" "+"Cargo: "+element.employee_position, selected: false, company: element.company});
                });
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
                this.contractsOptions = [];
                this.contractsOptions.push({id: '', name: 'Error'});
            }
        );

    }
    public filter_contracts (values) {
      
      this.filters = [];
      if(this.select_candidate_id)
      {  
          this.filters.push({'key': 'candidate_id-lk', 'value': this.select_candidate_id});
          this.filters.push({'key': 'activated-lk', 'value': '1'});
          this.getContracts();

      }

      
  }

    public showDocumentationDialogContract(contract) {

        this.selectContract = contract;
        //this.selectContractType = type;
        this.uploadedAttachment = [];
        var citation_id = contract.citation_id;
        var profile_survey_id = contract.profile_survey_id;
        // if(isNaN(this.tramite.value as any))
        // {
        //     console.log("hola no es numero");
        // }    
        this.contractService.getDocumentProfileSurveyUnionCheckListRad(this.edit.id,this.select_doc_id,citation_id,profile_survey_id).toPromise().then(        response => {
                // var result1 = JSON.parse(response.json());
                this.listDocuments = [];
                this.result = response.json();
                let list = [...this.listDocuments];
                this.result.data.forEach(element => {
                    list.push(element);
                    
                });
                this.listDocuments = list;
                if(this.listDocuments[0].document_profile_survey.length > 0){
                    this.blockCandiateAndContract = true;
                    this.sel_contracts_available.disable();
                    this.tramite.disable();
                }
                else{
                    this.blockCandiateAndContract = false;
                    this.sel_contracts_available.enable();
                    this.tramite.enable();
                }
                if(this.firtsOnce == true)
                {
                    this.listdocumentedit=this.listDocuments[0].document_profile_survey.length;
                    this.firtsOnce = false;
                }
                else{}
                if(this.listdocumentedit < this.listDocuments[0].document_profile_survey.length)
                    this.cancelInvalid = true;
                else
                    this.cancelInvalid = false;     
                this.loading_upload=false;
            },
            error => {
                this.messages = [];
                this.messages.push( { severity: 'error', summary: 'error' } );
            }
    
        );
           
      }
    // public updateAttachmentDocumentProfileSurvey(event, contract, checklist_profile_survey) {
    public updateAttachmentDocumentProfileSurvey(event) {
        
        // var selectedcitation_id=parseInt(this.selectContract.citation_id);
        // var selectedprofile_survey=parseInt(this.selectContract.profile_survey_id);
        this.loading_upload=true;
        this.translate.get('uploading').subscribe((res: string) => {
            this.notificationsService.growlNotify('info', res + '...');
        });
    
          let id;
          /*if (checklist_profile_survey.document_profile_survey) {
            if (checklist_profile_survey.document_profile_survey.length > 0) {
              id = checklist_profile_survey.document_profile_survey[0].id;
            }
          }*/
    
          this.uploadedAttachment = [];
          for (const file of event.files) {
              this.uploadedAttachment.push(file);
          }
    
          this.promiseAttachment = this.uploadFilesService.updateAttachmentDocumentProfileSurvey(this.uploadedAttachment, id, this.selectContract.citation_id, this.selectContract.profile_survey_id, this.listDocuments[0].id, this.listDocuments[0].list_doc_profile_survey_id,this.edit.id).toPromise().then(
              response => {
                  this.translate.get('saved').subscribe((res: string) => {
                      this.notificationsService.growlNotify('success', res);
                      this.showDocumentationDialogContract(this.selectContract);
                    this.fileUpload.clear();
                  });
                  
              },
              error => {
                this.loading_upload=false;
                  let msg = '';
                  this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                      this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                          JSON.parse(error._body).errors.forEach(element => {
                              if (element.source) {
                                  if (element.source.pointer) {
                                      this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                          msg = msg + res3 + ', ';
                                      });
                                  }
                              }
                          });
                          this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                      });
                  });
              }
          );
          
      }
    
      public deleteAttachmentDocumentProfileSurvey(id) {
          this.promiseAttachment = this.uploadFilesService.deleteAttachmentDocumentProfileSurvey(id).toPromise().then(
              response => {
                  this.translate.get('saved').subscribe((res: string) => {
                      this.notificationsService.growlNotify('success', res);
                  });
                  delete this.uploadedAttachment[id];
                  this.showDocumentationDialogContract(this.selectContract);
              },
              error => {
                  let msg = '';
                  this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                      this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                          JSON.parse(error._body).errors.forEach(element => {
                              if (element.source) {
                                  if (element.source.pointer) {
                                      this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                          msg = msg + res3 + ', ';
                                      });
                                  }
                              }
                          });
                          this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                      });
                  });
              }
          );
      }
    
      public gotoAttachment(id) {
        window.open(this.apiUrl + '/list-document-profile-surveis/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
      }
    
      public gotoAttachmentDocumentProfileSurvey(id) {
          window.open(this.apiUrl + '/document-profile-surveis/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
      }
      public getCandidateIdAutocomplete (res_autocomplete) {
        if(res_autocomplete.id){
            this.results_contracts_availables=false;
            console.log(res_autocomplete);
            this.select_candidate_id=res_autocomplete.id;
            console.log(this.select_candidate_id);
            this.filter_contracts(true);
            this.listDocuments = [];
            this.modViewDialogDocumentation= false;
            
        }
        
     }
     public onChangeTram(tramValue) {
        console.log(tramValue);
        // this.select_doc_id=tramValue;
        if(!isNaN(tramValue as any))
            this.select_doc_id = tramValue;
        else
            this.select_doc_id = 0;
        console.log("la conversion es: "+this.select_doc_id);
    }
    onChangeSelectContract(id_contract){
        var showDocumentation=false;
        console.log("El id del contrato seleccionado es: "+id_contract);
        this.list_contracts.forEach(element => {
            if (id_contract == element.id) {
                this.selectContract=element;
                showDocumentation=true;
                
            } 
        });
        if(showDocumentation)
        {
            this.showDocumentationDialogContract(this.selectContract);
            this.modViewDialogDocumentation=true;   
        }

    }
    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }
    public onUploadFileDocumentProfileSurvey(event: any) {
        console.log(event);
    }
    /*public df()
    {
        if(tengo un contrato seleccionado (con info) y ademas tengo el tramite)
            traigo la informacion como la de relacion laboral
    }*/

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/radication-ss/new-radication-ss/new-radication-ss.component.ts